import React from 'react';
import {Typography} from 'components/Typography';

interface IOutOfStockBadgeProps {
    className?: string;
}

export const OutOfStockBadge = ({className}: IOutOfStockBadgeProps) => {
    return (
        <Typography className={className} variants={{DT: 'label-16-r', TB: 'label-14-r', MB: 'label-14-r'}}>
            Этот товар закончился
        </Typography>
    );
};
